import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { EtablissementContactForm, GeneralContactForm, CoordonneesEtudiantForm } from '../models/contactForm.model';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ContactFormService {
    apiUrl = environment.apiUrl;
    etablissementContactFormResponse: any;
    generalContactFormResponse: any;
    coordonneesEtudiantFormResponse: any;

    constructor(private http: HttpClient) { }

    sendEtablissementForm(etablissementContactForm: EtablissementContactForm): Observable<any> {
        return this.http.post(`${this.apiUrl}/etablissementContact`, { data: etablissementContactForm })
          .pipe(map((res) => {
            this.etablissementContactFormResponse = res['data'];
            return this.etablissementContactFormResponse;
          }),
          catchError(this.handleError));
    }

    sendGeneralForm(generalContactForm: GeneralContactForm): Observable<any> {
        return this.http.post(`${this.apiUrl}/generalContact`, { data: generalContactForm })
          .pipe(map((res) => {
            this.generalContactFormResponse = res['data'];
            return this.generalContactFormResponse;
          }),
          catchError(this.handleError));
    }

    sendCoordonneesEtudiantForm(coordonneesEtudiantForm: CoordonneesEtudiantForm): Observable<any> {
      return this.http.post(`${this.apiUrl}/coordonnees_etudiant`, { data: coordonneesEtudiantForm })
        .pipe(map((res) => {
          this.coordonneesEtudiantFormResponse = res['data'];
          return this.coordonneesEtudiantFormResponse;
        }),
        catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
